if (!customElements.get('product-free-shipping-o2')) {
  customElements.define(
    'product-free-shipping-o2',
    class ProductFreeShippingO2 extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.closest('product-info')?.dataset.originalSection || this.dataset.sectionId;
        this.sourceId = `FreeShipping-${this.sectionId}`;
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refreshCartEligibility());
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (data.sectionId !== this.sectionId) return;

          const source = data.html.getElementById(this.sourceId);
          if (!source) return;
          this.dataset.variantId = source.dataset.variantId;
          this.dataset.isLargeItem = source.dataset.isLargeItem;
          this.updateVisibility();
        });
        this.refreshCartEligibility();
      }

      disconnectedCallback() {
        this.cartUpdateUnsubscriber?.();
        this.variantChangeUnsubscriber?.();
        this.abortController?.abort();
      }

      updateVisibility() {
        this.hidden =
          this.cartEligibilityPending ||
          this.dataset.isLargeItem === 'true' ||
          this.dataset.cartHasLargeItem === 'true';
      }

      async refreshCartEligibility() {
        this.abortController?.abort();
        const controller = new AbortController();
        this.abortController = controller;
        this.cartEligibilityPending = true;
        this.updateVisibility();

        const url = new URL(this.dataset.sectionUrl, window.location.origin);
        url.searchParams.set('variant', this.dataset.variantId);
        url.searchParams.set('section_id', this.sectionId);

        try {
          const response = await fetch(url, { signal: controller.signal });
          if (!response.ok) throw new Error(`Free shipping update failed: ${response.status}`);
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const source = html.getElementById(this.sourceId);
          if (!source || !this.isConnected || controller.signal.aborted) return;

          this.dataset.cartHasLargeItem = source.dataset.cartHasLargeItem;
          this.cartEligibilityPending = false;
          this.updateVisibility();
        } catch (error) {
          if (error.name !== 'AbortError') console.error(error);
        }
      }
    }
  );
}
